import { useContext, useEffect } from 'react';
import { SignalRContext } from './SignalRContext';

const useSignalRSubscription = (target, callback) => {
  const signalRContext = useContext(SignalRContext);

  useEffect(() => {
    if (!signalRContext) {
      return;
    }

    signalRContext.on(target, callback);

    return () => {
      signalRContext.off(target, callback);
    };
  }, [signalRContext, target, callback]);
};

export default useSignalRSubscription;
